import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import {
  IonButton,
  IonCol,
  IonGrid,
  IonIcon,
  IonItem,
  IonItemDivider,
  IonItemGroup,
  IonLabel,
  IonList,
  IonRow,
} from '@ionic/angular/standalone';
import { BatchImportStoreService } from '../batch-import-store.service';

@Component({
  selector: 'lib-batch-import-list',
  templateUrl: './batch-import-list.component.html',
  styleUrls: ['./batch-import-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    DatePipe,
    IonButton,
    IonCol,
    IonRow,
    IonGrid,
    IonIcon,
    IonItem,
    IonLabel,
    IonItemDivider,
    IonItemGroup,
    IonList,
    RouterLink,
    RouterLinkActive,
  ],
})
export class BatchImportListComponent {
  private readonly batchImportStoreService = inject(BatchImportStoreService);
  public readonly detailRoute = input.required<string>();

  protected readonly batchImports = computed(() => {
    const snapshot = this.batchImportStoreService.batchImports.snapshot();

    return snapshot.status === 'error' ? [] : snapshot.value;
  });
}
